import { motion } from "framer-motion";
import { brandConfig } from "../../config/brand";
import CyberButton from "../ui/CyberButton";

interface IntroScreenProps {
  onContinue: () => void;
}

export default function IntroScreen({ onContinue }: IntroScreenProps) {
  const { logo, mainBox, title, subtitle, colors } = brandConfig;

  return (
    <motion.div
      className="flex flex-col items-center justify-center min-h-screen w-full overflow-hidden relative bg-black"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1, ease: "easeInOut" }}
    >
      {/* Background overlay */}
      <div className="absolute inset-0 opacity-20 bg-[url('/assets/backgrounds/grid.svg')] bg-repeat bg-center" />

      {/* --- TITLE + LOGO --- */}
      <motion.div
        className="flex items-center gap-2 md:gap-4 z-10 text-center select-none"
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <img
          src={logo}
          alt="Brand Logo"
          className="w-[50px] sm:w-[70px] md:w-[90px] object-contain"
        />
        <h1
          className="text-[42px] sm:text-[64px] md:text-[96px] font-extrabold uppercase tracking-tight bg-clip-text text-transparent"
          style={{ backgroundImage: colors.gradient }}
        >
          {title}
        </h1>
      </motion.div>

      <p
        className="mt-2 sm:mt-3 z-10 text-base sm:text-lg font-semibold bg-clip-text text-transparent"
        style={{ backgroundImage: colors.secondary }}
      >
        {subtitle.pre} {subtitle.highlight}
      </p>

      {/* --- LOOTBOX IMAGE --- */}
      <motion.img
        src={mainBox}
        alt="Lootbox"
        className="mt-10 sm:mt-12 md:mt-16 w-[240px] sm:w-[360px] md:w-[480px] lg:w-[560px] drop-shadow-[0_0_40px_rgba(255,215,0,0.25)] max-h-[50vh] object-contain"
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.9, duration: 0.9, ease: "easeOut" }}
      />

      {/* --- CTA BUTTON --- */}
      <CyberButton
        onClick={() => {
          console.log("PLAY NOW clicked");
          onContinue();
        }}
        className="mt-6 sm:mt-10"
      >
        PLAY NOW
      </CyberButton>

      {/* Glow behind box */}
      {/* <div className="absolute w-[800px] h-[800px] bg-yellow-400/10 blur-[120px] rounded-full bottom-[10%] z-[-99999]" /> */}
    </motion.div>
  );
}
